/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EventLinkFlagBundle {
    YOUTUBE = 'YOUTUBE',
    INSTAGRAM = 'INSTAGRAM',
    FACEBOOK = 'FACEBOOK',
}
